import { Injectable } from '@angular/core';
import { SiteNavigationIntl } from '@knorr-bremse-portals/ngx-components/components/header';

@Injectable({providedIn: 'root'})
export class LocalSiteNavigationIntl extends SiteNavigationIntl {

  public override overviewMenuEntryPrefix = $localize `:site navigation overview menu entry prefix@@4442926641425549164:Go to`;
  public override breadcrumbHomeLabel = $localize `:site navigation breadcrumb home label@@2821179408673282599:Home`;
  public override openNavigationButtonLabel = $localize `:site navigation open navigation button label@@5034473762587110175:Open navigation`;

}
